import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { DimensionInput } from 'dashboards/types/dimension';
import { FilterInput } from 'dashboards/types/filter';
import { Sort } from 'types/column';
import { TimeRangeInput } from 'dashboards/types/time';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

type UseLeaderboardParams = {
  metricName: string;
  dimensions: Array<DimensionInput>;
  timeRange: TimeRangeInput;
  rowLimit: number;
  sort: Sort;
  filters: Array<FilterInput>;
  timeZone: string;
};

type UseLeaderboardOptions = UseQueryOptions<
  { headers: string[]; rows: string[][] },
  APIError
> & {
  params: UseLeaderboardParams;
};

export function useLeaderboard({
  queryKey = ['leaderboard'],
  params,
  ...options
}: UseLeaderboardOptions) {
  const { applicationID, client } = useAPI();

  const queryParams = {
    ...params,
    dimensions: params.dimensions.map(({ columnName }) => columnName),
  };

  return useAuthenticatedQuery(
    [...queryKey, queryParams],
    async () => {
      const { data } = await client.post(
        `/apps/${applicationID}/user_metrics/leaderboard`,
        queryParams
      );

      return data;
    },
    { ...options }
  );
}
